var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnesthesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.6889C5.68656 17.4081 3.95637 14.0842 5.67389 11.1107L9.65976 4.20997C10.5916 2.59668 13.4084 2.59667 14.3402 4.20997L18.3261 11.1107C20.0436 14.0842 18.3134 17.4081 15 18.6889M12 14C14 17.0004 7.50023 22.0004 18 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnesthesia);
export default __webpack_public_path__ + "static/media/Anesthesia.ef05ec34d9c8934b9b573fcd9c98b3f0.svg";
export { ForwardRef as ReactComponent };